export const conditionAndServiceStageId = "condition-and-service-stage-vehicle-details"
